<template>
  <Header/>
  <div class="container mt-4">
    <h3>Токены проекта</h3>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Проект</label>
        <select class="form-select" v-model="projectCurrent" @change="onProjectChange">
          <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
      </div>
      <div class="col-md-6 d-flex align-items-end">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="showDeleted" v-model="showDeleted">
          <label class="form-check-label" for="showDeleted">Показывать удалённые</label>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body d-flex align-items-end gap-3">
        <div>
          <label class="form-label">Дата старта AB-теста</label>
          <input type="date" class="form-control" v-model="startDate">
        </div>
        <button class="btn btn-primary"
                :disabled="selected.length < 2 || !startDate"
                @click="assignAbtest">
          Назначить в AB-тест ({{ selected.length }})
        </button>
      </div>
    </div>

    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th></th>
          <th>Имя</th>
          <th>Сайт</th>
          <th>token</th>
          <th>AB</th>
          <th>startDate</th>
          <th>Статус</th>
          <th>Действие</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in filteredTokens" :key="t.token" :class="{ 'text-muted': t.deleted === true }">
          <td><input type="checkbox" :value="t.token" v-model="selected"></td>
          <td>{{ t.name }}</td>
          <td>{{ t.site }}</td>
          <td><small>{{ t.token }}</small></td>
          <td>{{ t.abtest != null ? t.abtest : '—' }}</td>
          <td>{{ t.startDate || '—' }}</td>
          <td>
            <span v-if="t.deleted === true" class="badge bg-secondary">удалён</span>
            <span v-else class="badge bg-success">активен</span>
          </td>
          <td>
            <button class="btn btn-sm"
                    :class="t.deleted === true ? 'btn-outline-success' : 'btn-outline-danger'"
                    @click="toggleDeleted(t)">
              {{ t.deleted === true ? 'Восстановить' : 'Удалить' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';

export default {
  name: "TokensPage",
  components: { Header },
  data() {
    return {
      hostApi: process.env.VUE_APP_API_URL,
      projects: [],
      projectCurrent: localStorage.getItem('projectCurrent') || null,
      tokens: [],
      selected: [],
      showDeleted: true,
      startDate: '',
    };
  },
  computed: {
    filteredTokens() {
      if (this.showDeleted) return this.tokens;
      return this.tokens.filter(t => t.deleted !== true);
    },
  },
  created() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    this.getProjects();
  },
  methods: {
    getProjects() {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/project/get', { clientId: localStorage.getItem('clientId') })
        .then(function (response) {
          vm.projects = response.data.data;
          if (vm.projectCurrent && vm.projects.find(p => p.id === vm.projectCurrent)) {
            vm.getTokens();
          }
        })
        .catch(function (error) { console.log(error); });
    },
    onProjectChange() {
      localStorage.setItem('projectCurrent', this.projectCurrent);
      this.selected = [];
      this.getTokens();
    },
    getTokens() {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/token/get', { projectId: this.projectCurrent })
        .then(function (response) { vm.tokens = response.data; })
        .catch(function (error) { console.log(error); });
    },
    toggleDeleted(t) {
      const newDeleted = t.deleted !== true;
      const action = newDeleted ? 'удалить' : 'восстановить';
      if (!window.confirm(`Точно ${action} токен «${t.name}»?`)) return;
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/token/setDeleted', { token: t.token, deleted: newDeleted })
        .then(function () { vm.getTokens(); })
        .catch(function (error) { console.log(error); });
    },
    assignAbtest() {
      if (this.selected.length < 2 || !this.startDate) return;
      if (!window.confirm(`Объединить ${this.selected.length} токенов в один AB-тест со стартом ${this.startDate}?`)) return;
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/token/assignAbtest', {
        projectId: this.projectCurrent,
        tokens: this.selected,
        startDate: this.startDate,
      })
        .then(function (response) {
          window.alert('Назначен AB-тест №' + response.data.newAb);
          vm.selected = [];
          vm.getTokens();
        })
        .catch(function (error) { console.log(error); });
    },
  },
  watch: {
    showDeleted() {
      const visible = new Set(this.filteredTokens.map(t => t.token));
      this.selected = this.selected.filter(id => visible.has(id));
    },
  },
};
</script>
